<template>
  <v-card>
    <v-card-title>
      Zakolejkuj nowe powiadomienie
    </v-card-title>
    <v-card-text>
      <AddNotification/>
    </v-card-text>
  </v-card>
</template>

<script>
import AddNotification from "@/components/notifications/AddNotification";

export default {
  components: {
    AddNotification,
  }
}
</script>